import { useState, useEffect } from 'react'
import { PurchaseRequestStatusHistory } from '../types'
import { loadPurchaseRequestHistory } from '../lib/api'
import { getPurchaseStatusLabel } from '../lib/purchaseRequestStatus'
import './PurchaseRequestHistory.css'

interface PurchaseRequestHistoryProps {
  requestId: string
}

function PurchaseRequestHistory({ requestId }: PurchaseRequestHistoryProps) {
  const [history, setHistory] = useState<PurchaseRequestStatusHistory[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadHistory()
  }, [requestId])

  const loadHistory = async () => {
    try {
      setLoading(true)
      const data = await loadPurchaseRequestHistory(requestId)
      setHistory(data)
    } catch (error) {
      console.error('Chyba při načítání historie:', error)
    } finally {
      setLoading(false)
    }
  }

  const getStatusLabel = getPurchaseStatusLabel

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('cs-CZ', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  if (loading) {
    return <div className="history-loading">Načítání historie...</div>
  }

  if (history.length === 0) {
    return <div className="history-empty">Žádná historie změn</div>
  }

  return (
    <div className="purchase-request-history">
      <h3>Historie změn statusu</h3>
      <table className="history-table">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Z předchozího statusu</th>
            <th>Na nový status</th>
            <th>Změnil</th>
            <th>Poznámky</th>
          </tr>
        </thead>
        <tbody>
          {history.map((item) => (
            <tr key={item.id}>
              <td>{formatDate(item.created_at)}</td>
              <td>{item.old_status ? getStatusLabel(item.old_status) : '-'}</td>
              <td><strong>{getStatusLabel(item.new_status)}</strong></td>
              <td>{item.changed_by_name || 'Neznámý'}</td>
              <td>{item.notes || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default PurchaseRequestHistory

